export default {
  galleries: ['/styles/fashion','/styles/children','/styles/animals', '/styles/retro', '/styles/portraits','/styles/people',
    '/styles/maps'],
  animGalleries: [ 
    '/styles/animation/2d','/styles/animation/3d','/styles/animation/character-design',
    '/styles/animation/children','/styles/animation/explainers','/styles/animation/gifs','/styles/animation/motion-graphics'
  ],
  getRandomGallery: function (animation) {
    let m = 0
    if(!animation) {
      m = Math.floor(Math.random() * this.galleries.length)
      return this.galleries[m]
    }
    m = Math.floor(Math.random() * this.animGalleries.length)
    return this.animGalleries[m]
  }


}